/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Draft
 *
 * 2 = Submit
 *
 * 3 = Status
 *
 * 4 = Printing
 */
export enum StageType {
  Draft = 1,
  Submit = 2,
  Status = 3,
  Printing = 4,
}
